import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteUser } from '../api/users';
import { Queries } from '../types/queries';

/** Deletes a user and refreshes the user directory after success. */
const useDeleteUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteUser,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [Queries.UserList] }),
  });
};

export default useDeleteUser;
